import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Component({
  selector: 'app-icon-close',
  templateUrl: './icon-close.component.html',
  styleUrls: ['./icon-close.component.less'],
})
export class IconCloseComponent implements OnInit {

  @Input() buttonActive$? = new BehaviorSubject(false);
  @Input() buttonActive?: boolean = false;
  @Input() icon!: string;

  constructor() {}

  ngOnInit(): void {}
}
